// src/prototype/components/ea_reports/use_case/EAUseCaseSummaryStrip.tsx
// ============================================================
// DVA EA USE CASE ARTIFACT — SUMMARY STRIP
// ============================================================
// Horizontal band of key metrics shown beneath the header.
// Accepts an array of { label, value, accent? } objects.
// Renders as a flex row with dividers between cells.
// ============================================================

import React from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// TYPES
// ─────────────────────────────────────────────────────────────────────────────

export interface SummaryMetric {
  /** Short label shown above the value, e.g. "Annual Value" */
  label: string;
  /** The formatted value string, e.g. "$11.8M – $22.7M" */
  value: string;
  /**
   * When true the value renders in coral (#FF6E4C) to draw attention.
   * Use for recommendation status, tier, or key financial figures.
   */
  accent?: boolean;
  /**
   * Optional sub-text shown below the value in muted style.
   * e.g. "annual impact" or "at 84% confidence"
   */
  sub?: string;
}

export interface EAUseCaseSummaryStripProps {
  metrics: SummaryMetric[];
}

// ─────────────────────────────────────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────────────────────────────────────

export const EAUseCaseSummaryStrip: React.FC<EAUseCaseSummaryStripProps> = ({ metrics }) => (
  <div className="ua-summary-strip">
    {metrics.map((m, i) => (
      <div key={i} className="ua-summary-item">
        <div className="ua-summary-label">{m.label}</div>
        <div className={`ua-summary-value${m.accent ? ' accent' : ''}`}>{m.value}</div>
        {m.sub && (
          <div
            style={{
              fontSize: '6.5pt',
              fontWeight: 500,
              color: '#9ca3af',
              marginTop: '2px',
              letterSpacing: '0.02em',
            }}
          >
            {m.sub}
          </div>
        )}
      </div>
    ))}
  </div>
);

export default EAUseCaseSummaryStrip;